// Figma: the pill "Background" + label pattern used for the Account Status stat card and
// the Campaigns table's Status/Offers/Targets cells (e.g. nodes 18034:1385, 18034:1641,
// 18034:1649). One reusable pill, colored by `variant`.
import React from 'react';
import PropTypes from 'prop-types';
import {Box, Typography} from '@mui/material';

const VARIANTS = {
    info: {bg: '#eff6ff', border: '#bedbff', text: '#155dfc'},
    success: {bg: '#d9fbe8', border: '#b3f5d1', text: '#00a155'},
    neutral: {bg: '#f5f5f5', border: '#e5e5e5', text: '#525252'}
};

const Badge = ({label, variant = 'neutral'}) => {
    const colors = VARIANTS[variant] || VARIANTS.neutral;
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                height: '24px',
                px: 1,
                borderRadius: '999px',
                backgroundColor: colors.bg,
                border: `1px solid ${colors.border}`
            }}
        >
            <Typography variant="caption" fontWeight={500} sx={{color: colors.text}}>
                {label}
            </Typography>
        </Box>
    );
};

Badge.propTypes = {
    label: PropTypes.node.isRequired,
    variant: PropTypes.oneOf(['info', 'success', 'neutral'])
};

export default Badge;
